import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc5a61ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-col justify-center items-center h-full min-h-screen" }
const _hoisted_3 = {
  key: 1,
  class: "w-full animate__animated animate__fadeIn animate__delay-0.4s"
}
const _hoisted_4 = { class: "w-full flex flex-col justify-center items-center" }
const _hoisted_5 = { class: "w-full flex flex-row justify-center items-center space-x-8" }
const _hoisted_6 = {
  key: 0,
  class: "w-full p-5 bg-white rounded-lg shadow-card space-y-4"
}
const _hoisted_7 = { class: "text-gray-400 text-base" }
const _hoisted_8 = { class: "font-semibold text-black" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" last edited")
const _hoisted_10 = { class: "text-xl font-semibold" }
const _hoisted_11 = { class: "w-full p-5 bg-white rounded-lg shadow-card space-y-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-base" }, "Published", -1))
const _hoisted_13 = { class: "text-xl font-semibold" }
const _hoisted_14 = {
  key: 1,
  class: "w-full p-5 bg-white rounded-lg shadow-card space-y-4"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-base" }, "Last job published", -1))
const _hoisted_16 = { class: "text-xl font-semibold" }
const _hoisted_17 = { class: "mt-8 w-full p-5 bg-white rounded-lg shadow-card" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-base font-semibold" }, "Your company's careers page is published"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-400" }, " Here is a preview: ")
], -1))
const _hoisted_19 = { class: "mt-6" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "w-full bg-white flex flex-col justify-center items-center" }
const _hoisted_22 = { class: "w-full lg:w-12/12 flex flex-col mb-8 lg:px-12 lg:py-6 md:px-12 md:py-6 sm:px-4 sm:py-2 px-5 py-4" }
const _hoisted_23 = { class: "w-full flex lg:flex-row md:flex-row flex-col lg:space-x-8 md:space-x-8 justify-start items-start" }
const _hoisted_24 = { class: "relative logo-company-preview -mt-16 bg-white shadow-card rounded-lg flex flex-row justify-center items-center rounded-lg" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "w-full text-center mt-5 lg:mt-0 md:mt-0 lg:text-left md:text-left" }
const _hoisted_27 = { class: "text-gray-600 font-semibold text-3xl" }
const _hoisted_28 = { class: "font-thin text-sm text-gray-400 text-justify mt-1 leading-tight" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t-2 py-4" }, null, -1))
const _hoisted_30 = { class: "w-full flex flex-row space-x-3 items-center" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5 mr-2",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" })
], -1))
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Edit job board page ")
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "bg-white w-full mt-8 shadow-card p-5 rounded-lg" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-base font-semibold" }, "Share job board"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-normal text-gray-400" }, "Share your company's job board with the world. The job board reflects all your published job openings and allows candidates to apply to them.")
], -1))
const _hoisted_37 = { class: "flex flex-row mt-3 w-8/12" }
const _hoisted_38 = { class: "px-3 py-3 border border-gray-300 text-gray-400 text-sm bg-gray-100 font-medium rounded-l-full w-full" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5 mr-2",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "8",
    y: "8",
    width: "12",
    height: "12",
    rx: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" })
], -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Copy ")
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_CustomCompany = _resolveComponent("CustomCompany")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Loader)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.company?.company_branding?.staff_name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, [
                      _createElementVNode("strong", _hoisted_8, _toDisplayString(_ctx.company?.company_branding?.staff_name), 1),
                      _hoisted_9
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.timeAgo(_ctx.company?.company_branding?.updated_at)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.company?.company_branding?.published_jobs) + " Jobs", 1)
                ])
              ]),
              (_ctx.company?.company_branding?.last_job_published)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.timeAgo(_ctx.company?.company_branding?.last_job_published)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: "flex flex-col relative hero",
                style: _normalizeStyle({
            'background-color': `${_ctx.hexToRGBA(
              _ctx.company?.company_branding?.primary_color,
              1
            )}`,
          })
              }, [
                (_ctx.company?.company_branding?.background?.url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.company?.company_branding?.background?.url,
                      class: "absolute inset-0 object-cover w-full h-full animate__animated animate__fadeIn animate__delay-0.4s z-1",
                      alt: ""
                    }, null, 8, _hoisted_20))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "relative bg-opacity-40 hero",
                  style: _normalizeStyle({
              'background-color': `${_ctx.hexToRGBA(
                _ctx.company?.company_branding?.primary_color,
                0.2
              )}`,
            })
                }, null, 4)
              ], 4),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      (_ctx.company?.company_branding?.logo?.url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "object-cover bg-white rounded-lg w-full h-full animate__animated animate__fadeIn animate__delay-0.4s",
                            src: _ctx.company?.company_branding?.logo?.url,
                            alt: ""
                          }, null, 8, _hoisted_25))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.company.name), 1),
                      _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.company?.company_branding?.description), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal = true)),
                class: "flex flex-row bg-primary text-white rounded-full px-5 py-3 items-center text-sm"
              }, _hoisted_33),
              _createElementVNode("a", {
                href: _ctx.companyDomain,
                target: "_blank",
                class: "text-primary font-medium px-5 py-2 rounded-lg hover:bg-gray-50 cursor-pointer"
              }, " View job board page ", 8, _hoisted_34)
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.companyDomain), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args))),
                class: "px-3 py-3 text-gray-400 text-sm font-medium text-purple-500 border-2 border-purple-500 flex flex-row justify-center items-center rounded-r-full border-l-2"
              }, _hoisted_41)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ReusableModal, {
      show: _ctx.openModal,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal = false)),
      size: "w-2/4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CustomCompany, {
          onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal = false)),
          onUpdateBranding: _ctx.updateBranding,
          company: _ctx.company
        }, null, 8, ["onUpdateBranding", "company"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}